import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { CircleFlag } from "react-circle-flags";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const containerRef = useRef(null);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setIsDropdownOpen(false);
  };

  const handleBlur = (event) => {
    if (
      containerRef.current &&
      event.relatedTarget &&
      containerRef.current.contains(event.relatedTarget)
    ) {
      return;
    }
    setIsDropdownOpen(false);
  };

  return (
    <div
      ref={containerRef}
      className="fixed z-[2000] bottom-8 right-8 m-2 w-14 h-14 flex items-center justify-center"
      tabIndex={-1}
      onBlur={handleBlur}
    >
      {/* Language Button */}
      <button
        className="w-14 h-14 bg-green-700 hover:bg-green-800 text-white rounded-full flex items-center justify-center transition-all"
        style={{
          boxShadow:
            "0 8px 16px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2)",
        }}
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        <FontAwesomeIcon icon={faLanguage} className="text-3xl" />
      </button>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div
          className="absolute bottom-16 right-0 bg-white rounded-lg shadow-lg p-2"
          tabIndex={-1}
        >
          <ul className="list-none">
            <li
              onClick={() => handleLanguageChange("en")}
              className="pl-3 pr-10 py-2 cursor-pointer hover:bg-green-200 flex items-center"
            >
              <CircleFlag
                countryCode="gb"
                style={{ width: "25px", height: "25px" }}
                className="mr-2"
              />
              English
            </li>
            <li
              onClick={() => handleLanguageChange("al")}
              className="pl-3 pr-10 py-2 cursor-pointer hover:bg-green-200 flex items-center"
            >
              <CircleFlag
                countryCode="al"
                style={{ width: "25px", height: "25px" }}
                className="mr-2"
              />
              Shqip
            </li>
            <li
              onClick={() => handleLanguageChange("mk")}
              className="pl-3 pr-10 py-2 cursor-pointer hover:bg-green-200 flex items-center"
            >
              <CircleFlag
                countryCode="mk"
                style={{ width: "25px", height: "25px" }}
                className="mr-2"
              />
              Македонски
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
